import { Box, Skeleton } from "@mui/material";
import HomeSegmentTitle from "../HomeSegmentTitle";
import HomeSegmentCard from "../HomeSegmentCard";
import HomeSegmentContent from "../HomeSegmentContent";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import EmojiObjectsOutlinedIcon from "@mui/icons-material/EmojiObjectsOutlined";
import LinkIcon from "@mui/icons-material/Link";

const rows = [...Array(25)].map(() => ({
  skeleton: (
    <Skeleton
      variant="rounded"
      height={20}
      sx={{ backgroundColor: "#EBEBEB", width: "100%" }}
    />
  ),
}));

export const insightTableSkeleton = (
  <>
    <TableHead component={Paper}>
      <TableRow>
        <TableCell>Created By</TableCell>
        <TableCell align="left">Date</TableCell>
        <TableCell align="center">Interviewee</TableCell>
        <TableCell align="center">Priority</TableCell>
        <TableCell align="center">Quote</TableCell>
        <TableCell align="center">Comment</TableCell>
        <TableCell align="center">
          <LinkIcon sx={{ color: "inherit", fill: "none" }}></LinkIcon>
        </TableCell>
        <TableCell align="center">Tags</TableCell>
      </TableRow>
    </TableHead>
    <TableBody component={Paper}>
      {rows.map((row, index) => (
        <TableRow
          key={index}
          sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
        >
          <TableCell align="center">
            <Skeleton
              variant="circular"
              height={50}
              width={50}
              sx={{ backgroundColor: "#EBEBEB", width: "100%" }}
            />
          </TableCell>
          <TableCell align="left">{row.skeleton}</TableCell>
          <TableCell align="center">{row.skeleton}</TableCell>
          <TableCell align="center">{row.skeleton}</TableCell>
          <TableCell align="center">{row.skeleton}</TableCell>
          <TableCell align="center">{row.skeleton}</TableCell>
          <TableCell align="center">{row.skeleton}</TableCell>
          <TableCell align="center">{row.skeleton}</TableCell>
        </TableRow>
      ))}
    </TableBody>
  </>
);

const InsightSegmentCardSkeleton = () => {
  return (
    <HomeSegmentCard>
      <HomeSegmentTitle>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <EmojiObjectsOutlinedIcon /> Insights
        </Box>
      </HomeSegmentTitle>

      <HomeSegmentContent>
      <TableContainer component={Paper}>
      <Table aria-label="simple table">
        {insightTableSkeleton}
        </Table>
        </TableContainer>
        </HomeSegmentContent>
    </HomeSegmentCard>
  );
};

export default InsightSegmentCardSkeleton;
